import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext, useContext, useMemo, useState, } from 'preact/compat';
const CourseContext = createContext({
    isCourse: false,
    setIsCourse: () => null,
});
export function useCourse() {
    return useContext(CourseContext);
}
export function CourseProvider({ children }) {
    const [isCourse, setIsCourse] = useState(false);
    const value = useMemo(() => ({ isCourse, setIsCourse }), [isCourse]);
    return (_jsx(CourseContext.Provider, { value: value, children: children }));
}
